import { render, staticRenderFns } from "./FormVideo.vue?vue&type=template&id=03b8f062&scoped=true&"
import script from "./FormVideo.vue?vue&type=script&lang=js&"
export * from "./FormVideo.vue?vue&type=script&lang=js&"
import style0 from "./FormVideo.vue?vue&type=style&index=0&id=03b8f062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8f062",
  null
  
)

export default component.exports